"use strict";

if($('.modal-wrapper').length){
		$(window).on('load',function(){
			setTimeout(function(){
				$("body").addClass('modal-active');
			},5000);
		});

		$(function() {
		  $(document).on('click',function(e) {
		   if(!$(e.target).closest('.modal-overlay').length) {
		     $("body").removeClass('modal-active');
		   } else {
		     // ターゲット要素をクリックした時の操作
		   }
			});
		});

}




if($('.top-page #site-logo').length){

tl.set("#site-logo .panel-cover", {
			autoKill:false,
})

.to("#site-logo span:nth-of-type(1) .panel-cover", .25, {
	className: "+=active",
	ease: Power0.easeIn,
	delay: 0,

})
.to("#site-logo span:nth-of-type(2) .panel-cover", .25, {
	className: "+=active",
	ease: Power0.easeIn,
	delay: 0,

})
.to("#site-logo span:nth-of-type(3) .panel-cover", .25, {
	className: "+=active",
	ease: Power0.easeIn,
	delay: 0,

})
.to("#site-logo span:nth-of-type(1) .panel-content", .15, {
	className: "+=panel-visible",
	ease: Power0.easeIn,
	delay: 0,

})
.to("#site-logo span:nth-of-type(2) .panel-content", .15, {
	className: "+=panel-visible",
	ease: Power0.easeIn,
	delay: 0,

})
.to("#site-logo span:nth-of-type(3) .panel-content", .15, {
	className: "+=panel-visible",
	ease: Power0.easeIn,
	delay: 0,

})

.to("#site-logo span:nth-of-type(1) .panel-cover", .15, {
	className: "+=slide-active",
	ease: Power0.easeIn,
	delay: 0,

})
.to("#site-logo span:nth-of-type(2) .panel-cover", .15, {
	className: "+=slide-active",
	ease: Power0.easeIn,
	delay: 0,

})
.to("#site-logo span:nth-of-type(3) .panel-cover", .15, {
	className: "+=slide-active",
	ease: Power0.easeIn,
	delay: 0,

})
.to("", .25, {
	className: "+=active",
	ease: Power0.easeIn,
	delay: 0,

})
.to("", .15, {
	className: "+=panel-visible",
	ease: Power0.easeIn,
	delay: 0,

})
.to("", .15, {
	className: "+=slide-active",
	ease: Power0.easeIn,
	delay: 0,

})



}

if($('.top-page #right').length){

	tl.set("#site-logo #right", {
				autoKill:false,
	})
.to(['.icn-wrapper .panel-cover,.top-caption span .panel-cover,#right .coming .panel-cover,#right .date .panel-cover'], .5, {
	className: "+=active",
	ease: Power0.easeIn,
	delay: 0,
})
.to(['#right .coming,#right .date'], .15, {
	className: "+=active",
	ease: Power0.easeIn,
	delay: 0,
})
.to(['.icn-wrapper .panel-content,.top-caption span .panel-content,#right .coming .panel-content,#right .date .panel-content'], .15, {
	className: "+=panel-visible",
	ease: Power0.easeIn,
	delay: 0,
})
.to(['.icn-wrapper .panel-cover,.top-caption span .panel-cover, #right .coming .panel-cover,#right .date .panel-cover'], .25, {
	className: "+=slide-active",
	ease: Power0.easeIn,
	delay: 0,
})

.to(['#right .open .panel-cover'], .5, {
	className: "+=active",
	ease: Power0.easeIn,
	delay: 0,
})
.to(['#right .open'], .15, {
	className: "+=active",
	ease: Power0.easeIn,
	delay: 0,
})
.to([' #right .open .panel-content'], .15, {
	className: "+=panel-visible",
	ease: Power0.easeIn,
	delay: 0,
})
.to(['#right .open .panel-cover'], .25, {
	className: "+=slide-active",
	ease: Power0.easeIn,
	delay: 0,
})





}
